import React from 'react'

import { ISurveyQuestion } from '../../../Client/ISurvey'

import { ChoiceTypeField } from './ChoiceTypeField/ChoiceTypeField'
import { OpenTypeField } from './OpenTypeField/OpenTypeField'
import style from './Style.scss'

export const ReadQuestionCard = ({
  id,
  question,
  type,
  isMultiline,
  isMultipleChoice,
  choices,
}: ISurveyQuestion) => {
  return (
    <div className={style.cardContainer} id={id}>
      <div className={style.cardHead}>{question}</div>
      <div className={style.cardBody} key={'fixKeys'}>
        {type === 'open' ? (
          <OpenTypeField isMultiline={isMultiline} />
        ) : (
          <ChoiceTypeField
            isMultipleChoice={isMultipleChoice}
            choices={choices}
          />
        )}
      </div>
    </div>
  )
}
